/* unplugin-vue-components disabled */import { render } from "./DialogCustomView.vue?vue&type=template&id=16c288b6&scoped=true"
import script from "./DialogCustomView.vue?vue&type=script&lang=js"
export * from "./DialogCustomView.vue?vue&type=script&lang=js"

import "./DialogCustomView.vue?vue&type=style&index=0&id=16c288b6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c288b6"]])

export default __exports__